import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tooltip/dist/react-tooltip.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/*
dev
<React.StrictMode>
</React.StrictMode>
*/
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
    <meta charSet="UTF-8" />
    <HelmetProvider>
        <App />
    </HelmetProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
